import axios from "axios";

const instance = axios.create({
  baseURL: "http://143.244.132.221:4002",
});

export default instance;
